import { Theme, styled } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { MUIStyledCommonProps } from '@mui/system';
import Iconify from 'src/components/iconify/Iconify';
import { NAV } from 'src/config-global';

export const NavAccordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props}>
    {props.children}
  </MuiAccordion>
))(({ theme }) => {
  return {
    color: theme.palette.text.primary,
    '& .MuiAccordionSummary-root': {
      paddingLeft: theme.spacing(1.5),
      minHeight: theme.spacing(3.5),
    },
    '& .MuiAccordionSummary-content': {
      display: 'flex',
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      backgroundColor: 'transparent',
      borderRadius: 0,
      boxShadow: 'none',
    },
  };
});

export const NavAccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<Iconify icon="tabler:chevron-right" width={24} height={24} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  paddingTop: theme.spacing(0.4),
  paddingBottom: theme.spacing(0.4),
  paddingRight: theme.spacing(0.5),
  maxHeight: NAV.H_DASHBOARD_NAV_LABEL,
  '& .MuiAccordionSummary-expandIconWrapper': {
    '&.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    svg: {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
    },
  },
  '& .MuiAccordionSummary-content ': {
    margin: 0,
    marginLeft: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  '&.recents': {
    '& .navIcon': {
      color: theme.palette.success.main,
    },
  },
  '&.gathering': {
    '& .navIcon': {
      color: theme.palette.success.main,
      path: {
        fill: theme.palette.success.main,
      },
    },
  },
  '&.chat': {
    '& .navIcon': {
      color: theme.palette.primary.main,
    },
  },
  '&.dm': {
    '& .navIcon': {
      color: theme.palette.warning.main,
      path: {
        fill: theme.palette.warning.main,
      },
    },
  },
  '&.todos': {
    '& .navIcon': {
      color: theme.palette.warning.main,
    },
  },
  '&.board': {
    '& .navIcon': {
      color: theme.palette.collaborate[500],
    },
  },
  '&.docs': {
    '& .navIcon': {
      color: theme.palette.grey[400],
    },
  },
  '&.drive': {
    '& .navIcon': {
      color: theme.palette.drive[500],
    },
  },
}));

export const NavAccordionDetails = styled(MuiAccordionDetails)(({ theme }) => {
  const defaultCss = {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: theme.spacing(0),
  } as MUIStyledCommonProps<Theme>;

  const defaultListCss = {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  };

  return {
    ...defaultCss,
    '& .MuiList-root': {
      ...defaultListCss,
      padding: theme.spacing(0.25, 1.5, 0.75, 1.5),
    },
  };
});

export const NavAccordionLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));
